module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "e2e-single-upload-container"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "e2e-single-upload",
    attrs: {
      "action": _vm.localAction,
      "data": _vm.params,
      "auto-upload": _vm.autoUpload,
      "before-upload": _vm.localBeforeUpload,
      "on-change": _vm.onChange,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "headers": _vm.headers,
      "limit": _vm.limit,
      "disabled": _vm.disabled,
      "on-exceed": _vm.onExceed,
      "accept": _vm.localAccept,
      "multiple": _vm.multiple,
      "show-file-list": false,
      "with-credentials": true
    }
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0318f77e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0318f77e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upload/SingleUpload.vue
// module id = 1546
// module chunks = 7